import { httpClient } from '@/modules/common/services/http/http-client';
import { IBalancesResponse } from './types';

const consolidationHttp = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/consolidation`
});

export function getBalances(): Promise<IBalancesResponse> {
  return consolidationHttp.get('/v1/balance');
}
